package user.components


import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.grid.col
import antd.grid.row
import antd.input.input
import antd.modal.modal
import com.jingfangpai.api.clients.UserApiClient
import com.jingfangpai.user.model.UserAuthData
import kotlinext.js.jsObject
import kotlinx.browser.localStorage
import org.w3c.dom.events.Event
import react.*
import react.dom.*
import user.service.AuthService

external interface LoginModalProps : RProps {
    var visible:Boolean
    var onClose:()->Unit
    var onLoginSuccess:(userAuthData: UserAuthData)->Unit
}

val LoginModal = functionalComponent<LoginModalProps> { props ->

    val (modalShow,setModalShow) = useState(props.visible)
    val (userName,setUserName) = useState("")
    val (password,setPassword) = useState("")
    val (message,setMessage) = useState("")

    fun onLogin(){
        console.log(userName,password)
        setMessage("正在登录中，请稍候...")
        UserApiClient.login(userName,password,{
                apiResponse ->
            if(apiResponse.ok()){
                if(apiResponse.data!=null){
                    setMessage("登录成功")
                    AuthService.setUserAuthData(apiResponse.data!!,apiResponse.data!!.jwt?:"")
                    props.onLoginSuccess(apiResponse.data!!)
                }else{
                    setMessage("登录失败了,返回的授权信息为空")
                }
            }else{
                setMessage("登录失败了,${apiResponse.message}")
            }
        },{setMessage(it.message?:"")})
    }

    fun onTyping(){
        setMessage("");
    }

    useEffect(props.visible) {
        setModalShow(props.visible)
    }

    modal{
        attrs{
            title = "请先登录"
            visible = modalShow
            onCancel = {props.onClose()}
            footer = false
        }
        div("LoginModal") {

            form {
                attrs {
                    name = "login"
                    labelCol = jsObject {
                        span = "3"
                        pull = "left"
                    }
                }

                formItem {
                    attrs {
                        label = "用户名"
                    }
                    input {
                        attrs {
                            value = userName
                            name = "userName"
                            size = "large"
                            placeholder = "请输入用户名"
                            onChange = {event: Event ->
                                onTyping()
                                val _u = js("event.target.value") as String
                                localStorage.setItem(KEY_LAST_LOGIN_USER_NAME,_u)
                                setUserName(_u)
                            }
                        }
                    }
                }
                formItem {
                    attrs {
                        label = "密码"
                    }
                    input {
                        attrs {
                            value = password
                            name = "password"
                            type = "password"
                            size = "large"
                            placeholder = "请输入密码"
                            onChange = {event: Event ->
                                onTyping()
                                setPassword(js("event.target.value") as String)
                            }
                        }
                    }
                }
                if (!message.isBlank()){
                    formItem{
                        span{
                            +"登录失败：$message"
                        }
                    }
                }
                formItem {
                    attrs {
                        wrapperCol = jsObject {
                            span = "20"
                            offset = "18"
                        }
                    }
                    button {
                        attrs {
                            type = "primary"
                            onClick = {onLogin()}
                        }
                        +"登录"
                    }
                }
            }

        }
    }
}
